/* eslint-disable arrow-body-style */
import axios from 'axios';
import { jitsiLocalStorage } from '@jitsi/js-utils';

// const baseURL = 'https://api-develop.panthermediasystem.net';
const baseURL = 'https://api-prod.panthermediasystem.net';
// const baseURL = 'http://localhost:3600';

// export const hostName = 'dev.pantherconnect.me';
export const hostName = 'pantherconnect.me';


// const baseURL = 'http://localhost:3600';
// const baseURL = 'https://0384-2402-4000-2380-b4aa-39f8-6c60-2639-8dfc.in.ngrok.io';

const axiosConfig = axios.create({
    baseURL
});

let newAcessToken = null;

axiosConfig.interceptors.request.use(requestConfig => {
    let token = jitsiLocalStorage.getItem('token');

    if (newAcessToken) {
        token = newAcessToken;
    }
    if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
        requestConfig.headers.AccessToken = token;
    }

    return requestConfig;
});

const sourceRefreshToken = '/v2/auth/refresh';

const getRefreshToken = () => {
    const refreshToken = jitsiLocalStorage.getItem('refreshToken');

    return axiosConfig.post(`${sourceRefreshToken}`, {
        refresh_token: refreshToken
    });
};

let refreshingTokenData = null;

axiosConfig.interceptors.response.use(response => {
    return response;
}, async error => {

    const refreshToken = jitsiLocalStorage.getItem('refreshToken');
    const originalRequest = error.config;


    if (error?.response?.status === 403 && refreshToken && !originalRequest._retry) {

        try {
            originalRequest._retry = true;
            refreshingTokenData = refreshingTokenData ? refreshingTokenData : await getRefreshToken();

            console.log('refreshingTokenData', refreshingTokenData);
            const tokenData = refreshingTokenData;

            newAcessToken = tokenData.data.accessToken;
            refreshingTokenData = null;
            jitsiLocalStorage.setItem('token', tokenData.data.accessToken);
            jitsiLocalStorage.setItem('refreshToken', tokenData.data.refreshToken);
            originalRequest._queue = true;
            originalRequest.headers.Authorization = `Bearer ${tokenData.data.accessToken}`;
            originalRequest.headers.AccessToken = tokenData.data.accessToken;

            return axiosConfig(originalRequest);
        } catch (e) {
            // jitsiLocalStorage.removeItem('token');

            return Promise.reject(e);
        }
    } else {
        return Promise.reject(error);
    }
});


export default axiosConfig;

